export default __webpack_public_path__ + "static/media/vacations.3e4faf97.svg";